import {expeditorProDiscountOffer} from "./offers";

export default {
    id: "discount-expeditor-pro-2026",
    articleType: "release",
    slug: "skidka-50-ekspeditor-pro-2026",
    date: "8 августа 2026",
    dateTime: "2026-08-08",
    modifiedTime: "2026-08-08",
    author: "Редакция «Светофор Логистика»",
    category: "Тарифы · 2026",
    contentType: "Акция",
    title:
        "Скидка 50% на тариф «Экспедитор Про»: льготная цена до конца 2026 года",
    sidebarTitle: "Скидка 50% на «Экспедитор Про»",
    seoTitle:
        "Скидка 50% на тариф «Экспедитор Про» | «Светофор Логистика»",
    seoDescription:
        "До 31 августа 2026 года тариф «Экспедитор Про» доступен за 7 950 ₽ в месяц. Для подключившихся по акции льготная цена фиксируется до конца 2026 года.",
    image: "/img/news/skidka-50-ekspeditor-pro-2026/cover.webp",
    imageAlt:
        "Скидка 50% на тариф «Экспедитор Про» до 31 августа 2026 года",
    content: {
        subtitle:
            "Специальное предложение действует до 31 августа 2026 года включительно",
        lead: [
            "С 2026 года требования к логистике выросли: реестр ГосЛог, электронный документооборот, ЭТрН и подготовка к СОРМ стали частью повседневной работы экспедиторов.",
            "Чтобы закрыть эти задачи в одном решении, «Светофор Логистика» предлагает тариф «Экспедитор Про». До 31 августа 2026 года на него действует скидка 50%.",
        ],
        sections: [
            {
                icon: "%",
                title: "Условия акции",
                items: [
                    {
                        title: "7 950 ₽ в месяц",
                        text: "Цена по акции вместо 15 900 ₽ в месяц, без НДС.",
                    },
                    {
                        title: "Фиксация цены до конца 2026 года",
                        text: "Для тех, кто подключится во время акции, льготная цена 7 950 ₽ в месяц сохранится до конца 2026 года.",
                    },
                ],
            },
            {
                icon: "🛡️",
                title: "Юридическая безопасность",
                items: [
                    {
                        title: "Интеграция с ГосЛог",
                        text: "Данные о перевозках хранятся не менее трёх лет на защищённых серверах в России.",
                    },
                    {
                        title: "Отчётность для контролирующих органов",
                        text: "Платформа помогает автоматически формировать и отправлять необходимые сведения.",
                    },
                ],
            },
            {
                icon: "🚚",
                title: "Что входит в «Экспедитор Про»",
                items: [
                    {
                        title: "Мультиаккаунт",
                        text: "Работа в ролях грузовладельца и перевозчика в одном кабинете.",
                    },
                    {
                        title: "Спотовые рейсы и торги",
                        text: "Работа со спотовыми рейсами, аукционами и редукционами.",
                    },
                    {
                        title: "ЭДО и ЭТрН",
                        text: "Электронный документооборот и электронные транспортные накладные внутри платформы.",
                    },
                    {
                        title: "Интеграции",
                        text: "API-интеграция с 1С и другими корпоративными системами.",
                    },
                    {
                        title: "Контроль перевозки",
                        text: "Отслеживание грузов в пути и временные окна погрузки и разгрузки.",
                    },
                    {
                        title: "Кросс-докинг",
                        text: "Работа со сквозным складированием и транзитными операциями.",
                    },
                    {
                        title: "Мультимодальные рейсы",
                        text: "Поддержка железнодорожных, морских и авиационных плеч перевозки.",
                    },
                    {
                        title: "Аналитика и команда",
                        text: "Расширенная аналитика, отчёты, неограниченное число сотрудников и гибкие права доступа.",
                    },
                ],
            },
        ],
        callout: expeditorProDiscountOffer,
        notice: "Акция действует до 31 августа 2026 года включительно.",
    },
};
